import React from 'react';
import ReactDOM from 'react-dom';

import AsyncEditorContextProvider from '../../editor-context-provider/components/async-editor-context-provider';

import { WaBonaEditor } from './wa-bonaeditor';
import propTypes, { defaultProps } from './props';


class WaBonaEditorRawAdapter
{
  static propTypes = propTypes;

  static defaultProps = defaultProps;


  constructor(container)
  {
    if (!window.document.getElementById('idBonaEditorReactDialogsContainer'))
    {
      window.document.body.insertAdjacentHTML('beforeend', '<div id="idBonaEditorReactDialogsContainer"></div>');
    }

    this.container = container || window.document.createElement('DIV');

    if (!container)
    {
      window.document.getElementById('idBonaEditorReactDialogsContainer')
        .insertAdjacentElement('beforebegin', this.container);
    }
  }


  render = (props) =>
  {
    const {
      isOnlyLoad,
      callback,
      blankPageUrl,
      hideLinkStyleOption
    } = props;

    const reactElement =
      React.createElement(AsyncEditorContextProvider, { blankPageUrl, showLinkStyleOption: !hideLinkStyleOption },
        React.createElement(WaBonaEditor, (isOnlyLoad ?
          {
            isOnlyLoad: true,
            callback,
            editorConfig:
            {
              editorId: '',
              blankPageURL: '',
              toolbarConfigKey: ''
            },
            toolbarConfig:
            {
              toolbarContainerId: '',
              pToolbarStruct: ''
            }
          } :
          props),
        null));

    ReactDOM.render(reactElement, this.container, null);

    return reactElement;
  };


  unmount = () =>
  {
    ReactDOM.unmountComponentAtNode(this.container);
  };
}


if (window.WA && !WA.WaBonaEditorRawAdapter)
{
  WA.WaBonaEditorRawAdapter = WaBonaEditorRawAdapter;
}


export default WaBonaEditorRawAdapter;